// extracted by mini-css-extract-plugin
module.exports = {"inputButton":"Create_inputButton_27luA","checkbox":"Create_checkbox_1hJW-"};